@let cfg = config();

<aside
  [class]="
    'bg-white border-r border-default flex flex-col h-full transition-all duration-300 ease-in-out shrink-0 ' +
    (isTablet()
      ? collapsed()
        ? 'fixed left-0 top-0 z-50 h-screen w-full -translate-x-full'
        : 'fixed left-0 top-0 z-50 h-screen w-full translate-x-0'
      : collapsed() && cfg.collapseMode === 'mini'
        ? 'w-18 ml-0'
        : collapsed()
          ? 'w-52 -ml-52'
          : 'w-52 ml-0') +
    ' ' +
    (collapsed() && cfg.collapseMode !== 'mini' ? 'pointer-events-none' : '') +
    ' ' +
    styleClass()
  "
>
  <!-- Close Button for Mobile -->
  @if (showCloseButton()) {
    <div class="flex justify-end p-4">
      <button
        pButton
        pButtonAction
        type="button"
        aria-label="Close"
        (click)="collapsed.set(true)"
      >
        <i
          pButtonIcon
          class="pi pi-times"
        ></i>
      </button>
    </div>
  }

  @if (cfg.logo) {
    <div class="flex justify-center items-center overflow-hidden p-4 w-full">
      <img
        [src]="collapsed() && cfg.collapseMode === 'mini' ? (cfg.collapsedLogo ?? cfg.logo) : cfg.logo"
        [alt]="cfg.logoAlt ?? 'Logo'"
        [class]="'object-contain min-h-11' + (collapsed() ? '' : 'h-22')"
      />
    </div>
  }

  <div class="flex flex-1 flex-col items-start w-full h-full">
    @for (item of cfg.items; track $index) {
      @if (item.isHeader) {
        <!-- Section Header -->
        <div class="w-full px-4 pt-6 pb-2 text-xs font-semibold text-secondary uppercase tracking-wider">
          {{ item.label | transloco }}
        </div>
      } @else {
        <!-- Regular Menu Item -->
        <a
          pButton
          pButtonSidebar
          class="w-full relative"
          [class.pointer-events-none]="item.disabled"
          [class.justify-center]="collapsed() && cfg.collapseMode === 'mini'"
          [class.opacity-50]="item.disabled"
          [href]="item.route && !item.disabled ? item.route : undefined"
          [routerLink]="item.routerLink && !item.disabled ? item.routerLink : undefined"
          [routerLinkActiveOptions]="item.routerLinkActiveOptions ?? { exact: false }"
          routerLinkActive="selected"
        >
          <i
            pButtonIcon
            [class]="item.icon!"
          ></i>
          <span pButtonLabel>{{
            collapsed() && cfg.collapseMode === 'mini' ? undefined : (item.label | transloco)
          }}</span>
          @if (item.badge) {
            <p-badge
              [value]="item.badge"
              severity="danger"
              class="absolute top-2 right-2"
            />
          }
        </a>
      }
    }

    @if (cfg.bottomItems?.length) {
      <div class="mt-auto w-full">
        @for (item of cfg.bottomItems; track $index) {
          <a
            pButton
            pButtonSidebar
            class="w-full relative"
            [class.pointer-events-none]="item.disabled"
            [class.justify-center]="collapsed() && cfg.collapseMode === 'mini'"
            [class.opacity-50]="item.disabled"
            [href]="item.route && !item.disabled ? item.route : undefined"
            [routerLink]="item.routerLink && !item.disabled ? item.routerLink : undefined"
            [routerLinkActiveOptions]="item.routerLinkActiveOptions ?? { exact: false }"
            routerLinkActive="selected"
          >
            <i
              pButtonIcon
              [class]="item.icon!"
            ></i>
            <span pButtonLabel>{{
              collapsed() && cfg.collapseMode === 'mini' ? undefined : (item.label | transloco)
            }}</span>
            @if (item.badge) {
              <p-badge
                [value]="item.badge"
                [severity]="item.badgeSeverity || 'secondary'"
                class="absolute top-2 right-2"
              />
            }
          </a>
        }
      </div>
    }
  </div>
</aside>
